import { TrackRoute } from '@portals/shared-frontend/components';
import type { JSX } from 'react';

import HeroPage from '@/components/HeroPage';

import DeveloperPortalGuideContent from '../../components/Guide/DeveloperPortalGuideContent';

export default function LandingNew(): JSX.Element {
  return (
    <HeroPage
      banner="common"
      noTopMargin
      subtitle="Follow these steps to start consuming our APIs"
      title="Getting started"
    >
      <TrackRoute name="Getting Started" path="/getting-started" type="generic" />
      <DeveloperPortalGuideContent contentSlug="getting-started" />
    </HeroPage>
  );
}
